import React, {useEffect, useState} from "react";
import "./style.css";
import Lottie from 'react-lottie';
import animationData from '../../../../../static/json/questionnaire/weight-loss/LastingResults.json'


export const MobileLastingResults = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
    useEffect(() => {
        if (clicked) {
            clickNext("")
        }
    }, [clicked]);
  return (
    <div className="lasting-results-mobile" data-model-id="16759:1244">

      <div className="div">
        <div className="title">
          <p className="heading">Calo focuses on lasting results</p>
        </div>
          <div className={'lottie'}>
              <Lottie
                  options={{
                      loop: false,
                      autoplay: false,
                      animationData: animationData,
                      rendererSettings: {
                          preserveAspectRatio: 'xMidYMid slice'
                      }
                  }}
                  height={"calc(100vw * 244 / 375)"}
                  width={"100%"}
                  isPaused={!isCurPage} />

          </div>

        <p className="description">
          Calo&#39;s science-based approach helps you achieve lasting weight loss
          that fits your lifestyle.
        </p>
      </div>

    </div>
  );
};
